module.exports = __webpack_public_path__ + "img/news3.4670f775.png";